<div  class="pickuppath-popup">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pp-container">
                <div class="center-block pickup-path">
                  <div aria-label="Select Pickup Method" role="radiogroup" class="form-group path-select">
                    <b>Are You Ordering Pickup or Delivery?</b>
                    <hr aria-hidden="true">
                    <div class="custom-radio-container" *ngFor="let pickupPath of pickupPaths; let i= index">
                      <div class="radio custom-sm-radio" [ngClass]="{'selectedRadio': pickuptype && pickupPath.pickupPath == pickuptype}">
                        <input tabindex="{{i}}" attr.aria-label="{{pickupPath.pickupPathLabel}}" type="radio" name="pickupPath" id={{pickupPath.pickupPathLabel.toLowerCase()}} [(ngModel)]="pickuptype" [disabled] = "!pickupPath.enabled" [value] = "pickupPath.pickupPath"
                        (click)="pickupPathChange(pickupPath.pickupPath)" />
                      <label for={{pickupPath.pickupPathLabel.toLowerCase()}}>
                        <span aria-hidden="true" class={{pickupPath.iconClass}}>              
                        </span>{{(selectPickupService?.orderType === 'offer' || selectPickupService?.orderType === 'reward' ? 'Redeem Online' : 'Order') +' For ' + pickupPath.pickupPathLabel}}
                      </label>
                      </div>  
                      <hr aria-hidden="true">
                    </div>  
                  </div>
                  <div class="form-group text-center button-container">
                    <button (click) ="setPickupPath()" [disabled] ='disabled' class="btn wb-btn-default">
                      Set Pickup Method
                    </button> 
                  </div>
                </div>
        </div>
    </div>
</div>
